import React from 'react';

import NarrativeChapter from './NarrativeChapter';

const RELATIONSHIP_RULES = Object.freeze([
  {
    title: 'Limited window',
    body: 'Discovery is intentionally constrained so people are considered, not endlessly browsed.',
  },
  {
    title: 'Shared language',
    body: 'Introductions require at least one common language before two people can appear to each other.',
  },
  {
    title: 'Shared taste',
    body: 'Interests and passions are weighted by meaning, aligning on what shapes your lives.',
  },
  {
    title: 'Reflection first',
    body: 'Compatibility begins with how someone relates, not only photos, prompts, or proximity.',
  },
  {
    title: 'One active match',
    body: 'When it is mutual, Milan quiets discovery and gives that match room to develop.',
  },
]);

/**
 * Renders Milan's implemented relationship-product rules as explicit proof
 * points for reviewers and prospective users. Accepts no props.
 *
 * @param {object} props - Component properties.
 * @param {number} [props.index=1] - Zero-based guided-scroll chapter index.
 * @returns {React.ReactElement} Chapter one with five concrete product rules.
 * @sideEffects Has no external side effects beyond React rendering.
 */
export default function RelationshipRules({ index = 1 }) {
  return (
    <NarrativeChapter
      index={index}
      id="principles"
      eyebrow="Different by design"
      title="Built around rules, not volume."
      body="Milan keeps the love intent, but removes the high-volume mechanics that make swipe apps feel the same."
    >
      <div className="relationship-rules" aria-label="Milan relationship rules">
        {RELATIONSHIP_RULES.map((rule, idx) => (
          <article
            className="relationship-rule"
            key={rule.title}
            style={{ '--rule-index': idx }}
          >
            <h3>{rule.title}</h3>
            <p>{rule.body}</p>
          </article>
        ))}
      </div>
    </NarrativeChapter>
  );
}
